import React from "react";
import PublisherOnboarding from "./PublisherOnboarding";

const StandalonePublisherOnboarding = () => {
  return <PublisherOnboarding />;
};

export default StandalonePublisherOnboarding;
